import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** E-M1 — HARCELEUR. Le professeur de l'esquive TARDIVE.
 *
 *  Il se poste à mi-hauteur et lâche, par paires, des missiles GUIDÉS lancés
 *  droit vers le bas : ils ne visent pas, ils virent — et seulement une fois
 *  descendus près du joueur, d'un virage BORNÉ.
 *
 *  ── Ce qu'il enseigne ──
 *  Que tout mouvement ne se vaut pas. Contre un tir droit, s'écarter n'importe
 *  quand suffit. Contre un missile guidé, s'écarter TÔT ne fait que lui donner
 *  le temps de re-suivre : il faut casser sa course au dernier moment, quand il
 *  s'est engagé et ne peut plus se retourner. C'est la première menace du jeu
 *  qui punit la bonne réaction faite trop tôt — et la seule qui récompense le
 *  sang-froid de laisser le danger s'approcher.
 *
 *  ── Pourquoi une PAIRE en éventail, et pas un seul missile ──
 *  Lancés parallèles, deux missiles convergeraient invisiblement sur le joueur
 *  et se liraient comme un tir groupé lent. Ouverts à 30°, ils se REFERMENT sur
 *  lui : la courbe se voit, donc le guidage se voit. Une mécanique imperceptible
 *  n'existe pas, quel que soit le soin mis à l'écrire.
 *
 *  ── Ce qui garde l'esquive vivante ──
 *  La borne du virage (`turnDeg`) est le garde-fou : trop haute, le missile
 *  rattrape tout et l'esquive disparaît. Elle est MESURÉE, pas devinée
 *  (tests/sim/enemy-arsenal.test.ts vérifie qu'il touche un joueur immobile
 *  décalé ET qu'il rate un joueur qui casse sa course au bon moment). */
export default defineEnemy({
  id: 'harceleur',
  rank: Rank.Standard,
  hp: 200,
  visualRadius: 30,
  score: 280,
  telegraph: 1.1,
  drops: 2,
  motion: { kind: Motion.Hover, speed: 240, amplitude: 70, frequency: 0.7, holdY: 320 },
  emitter: {
    pattern: Pattern.Homing,
    every: 2.4,
    count: 2,
    spreadDeg: 30,
    // 460 u/s : bien sous le plafond de 1 500, et la conduite CONSERVE cette
    // norme (rotation pure) — un missile guidé ne peut donc jamais s'emballer.
    speed: 460,
    // 120 °/s de virage : le couple mesuré avec la portée d'acquisition (480 u,
    // moteur) qui tient les deux bords — rattrape un décalage que le tir droit
    // manque, rate une esquive tardive.
    turnDeg: 120,
    firstDelay: 1.6,
    family: Fam.EnemyPink,
  },
});
